// extracted by mini-css-extract-plugin
export default {"container":"add-payout-account-paypal-form_container__5wwYJ","loginButton":"add-payout-account-paypal-form_loginButton__7P1i5"};